import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { buildCombinedKey } from '../buildCombinedKey';
export var populateModulePaths = function populateModulePaths(outputMap, module) {
  var currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (module.key && module.type) {
    outputMap.set(buildCombinedKey(module.type, module.key), currentPath.join('.'));
  }
  if (module.zones) {
    Object.entries(module.zones).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        zoneKey = _ref2[0],
        value = _ref2[1];
      value.forEach(function (m, i) {
        if (m.data) {
          populateModulePaths(outputMap, m.data, [].concat(_toConsumableArray(currentPath), ["zones.".concat(zoneKey, "[").concat(i, "].data")]));
        }
      });
    });
  }
};
export var getModulePathsInSurface = function getModulePathsInSurface(surface) {
  var outputMap = new Map();
  populateModulePaths(outputMap, surface);
  return outputMap;
};